import { Loader } from "@mantine/core";
import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import { useSearchDrivers, UseSearchDriversParams } from "@/features/dashboard/pedidos/_hooks/useSearchDrivers";

import { Input } from "../_Input";

type DriversFieldsProps<TFieldValues extends FieldValues> = Omit<ComponentProps<typeof Input.Select<TFieldValues>>, "data" | "leftSection"> &
  Omit<UseSearchDriversParams, "search">;

export function DriversFields<TFieldValues extends FieldValues>({
  control,
  name,
  onSearchChange,
  searchValue,
  defaultSearchValue,
  getLabel,
  getValue,
  ...props
}: DriversFieldsProps<TFieldValues>) {
  const {
    data: searchShippingCompanyResults,
    actions: { setSearchDriver },
    state: { searchDriver, isFetching: isFetchingDrivers }
  } = useSearchDrivers({ search: defaultSearchValue, getLabel, getValue });

  const handleSearchChange = (value: string) => {
    setSearchDriver(value);
    onSearchChange?.(value);
  };

  return (
    <Input.Select
      data={searchShippingCompanyResults.options}
      leftSection={isFetchingDrivers && <Loader size="sm" />}
      searchValue={searchValue || searchDriver}
      onSearchChange={handleSearchChange}
      placeholder="Selecione o Motorista"
      label="Motorista"
      control={control}
      name={name}
      {...props}
    />
  );
}
